import styled, { css } from "styled-components";
import { device } from "../../../styled/device";
import QuestionMarkButton from "../QuestionMarkButton";

type WrapperProps = {
  disabled?: boolean;
};

type StyledInputProps = {
  invalid?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 288px;
  min-height: 44px;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `};

  @media (max-width: ${device.mobileS}) {
    width: 293px;
  }
`;

export const Label = styled.div`
  color: #777e91;
  font-size: 12px;
  font-family: Poppins-Regular, sans-serif;
  margin: 0 auto 6px 0;
  text-transform: uppercase;

  .tooltip {
    margin-left: 5px;
  }
`;


export const TooltipTrigger = styled.div`
  position: relative;
  //z-index: 2;
  padding-left: 8px;
`;

export const FieldQuestionMarkButton = styled(QuestionMarkButton)`
  height: 22px;
  width: 22px;

  & > img {
    width: 100%;
    height: 100%;
  }

  &:active {
    opacity: 0.8;
  }
`;

export const WrapperInput = styled.div`
  min-height: 44px;
  display: flex;
  flex-direction: column;
  position: relative;
  ${(props: WrapperProps) =>
    props.disabled &&
    css`
      opacity: 0.3;
      cursor: not-allowed;
    `}// +mf
    //     width: 100%
`;

export const LabelInput = styled.label`
  display: flex;
  align-items: center;
  max-width: 100%;
  color: #777e91;
  font-family: Poppins-Regular, sans-serif;
  font-size: 12px;
  line-height: 21px;
  text-transform: uppercase;
  margin-bottom: 6px;
  margin-right: auto;
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input`
  width: 100%;
  outline: none;
  margin: 0;
  font-family: Poppins, sans-serif;
  font-size: 16px;
  transition: background-color 0.25s ease-in-out, border-color 0.05s ease-in-out;
  color: #353945;
  padding: 13px 16px 13px 9px;
  box-sizing: border-box;
  border-radius: 7px;
  border: 1px solid #a2a2b4;
  text-overflow: ellipsis;
  height: 50px;
  ${(props: StyledInputProps) =>
    props.invalid &&
    css`
      border-color: #f84b7a;
    `}

  &::placeholder {
    font-family: Poppins-Regular, sans-serif;
    color: #9696b9;
    opacity: 1;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
  }
`;

export const ErrorMessage = styled.div`
  color: #f84b7a;
  font-size: 12px;
  position: absolute;
  white-space: nowrap;
  right: 0;
  bottom: -20px;
`;
